import { render } from "./SettingUp.vue?vue&type=template&id=3a6365be&scoped=true"
import script from "./SettingUp.vue?vue&type=script&lang=js"
export * from "./SettingUp.vue?vue&type=script&lang=js"

import "./SettingUp.vue?vue&type=style&index=0&id=3a6365be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6365be"]])

export default __exports__